import { motion } from "framer-motion";
import CompanyV2ServiceCardItem from "@/components/sections/company-v2/CompanyV2ServiceCardItem";
import { COMPANY_V2_SERVICES } from "@/components/sections/company-v2/serviceCardsData";

export default function ServiceSection() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6"
        >
          <div className="max-w-3xl">
            <div className="text-xs font-semibold tracking-[0.25em] uppercase text-[#0A2540]">
              What We Do — 03
            </div>
            <h2 className="font-display font-kr mt-5 text-4xl md:text-5xl font-bold tracking-tight leading-[1.1]">
              아이디어를 시스템으로<br />구현하는 8가지 영역.
            </h2>
          </div>
          <p className="font-kr text-base md:text-lg text-slate-600 leading-relaxed max-w-md">
            각 영역은 단독이 아닌 하나의 통합 흐름으로 운영됩니다.
          </p>
        </motion.div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {COMPANY_V2_SERVICES.map((service, i) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className="h-full"
            >
              <CompanyV2ServiceCardItem service={service} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
